import { render, staticRenderFns } from "./AssetCreateModal.vue?vue&type=template&id=5585af88&scoped=true"
import script from "./AssetCreateModal.vue?vue&type=script&lang=js"
export * from "./AssetCreateModal.vue?vue&type=script&lang=js"
import style0 from "./AssetCreateModal.vue?vue&type=style&index=0&id=5585af88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5585af88",
  null
  
)

export default component.exports